// extracted by mini-css-extract-plugin
export default {"Link":"Link_Link__u+0qO","Block":"Link_Block__a7qNG"};